import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import './pagination.scss';
import { Button} from '@mui/material';

const PaginationButtons = ({
  currentPage,
  pageSize,
  filteredSortedData,
  handlePageChange,
  totalPages,
  totalRecords,
  isFormValid,
  handleSaveAsDraft,
  handleSubmitForm,
}) => {
  useEffect(() => {
    const handleResize = () => {};
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  let startRecord = 0;
  let endRecord = 0;

  if (totalRecords === 0) {
    startRecord = 0;
    endRecord = 0;
  } else {
    startRecord = (currentPage - 1) * pageSize + 1;
    endRecord = Math.min(currentPage * pageSize, totalRecords);
  }


  return (
    <div className="pagination-container">
      <div className="pagination-info">
        Showing {startRecord}-{endRecord} of {totalRecords || filteredSortedData.length} records
      </div>
      <div className="pagination-controls">
        <button
          className="pagination-btn"
          onClick={() => handlePageChange(null, Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
        >
          <ChevronLeft fontSize="small" />
        </button>

        {currentPage === totalPages ? (
          <Button
            className="pagination-btn save-and-submit"
            variant="contained"
            onClick={handleSubmitForm} disabled={!isFormValid}
            style={{
              color: 'white',
              backgroundColor: '#6B5CE8',
            }}
          >
            Submit
          </Button>
        ) : (
          <Button
            className="pagination-btn save-and-submit"
            variant="contained"
            onClick={handleSaveAsDraft}
            style={{
              color: 'white',
              backgroundColor: '#6B5CE8',
            }}
          >
            Save
          </Button>
        )}

        <button
          className="pagination-btn"
          onClick={() => handlePageChange(null, Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
        >
          <ChevronRight fontSize="small" />
        </button>
      </div>
    </div>
  );
};

PaginationButtons.defaultProps = {
  handleSaveAsDraft: () => {},
  handleSubmitForm: () => {},
};

PaginationButtons.propTypes = {
  currentPage: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  filteredSortedData: PropTypes.array.isRequired,
  handlePageChange: PropTypes.func.isRequired,
  totalPages: PropTypes.any.isRequired,
  totalRecords: PropTypes.any.isRequired,
  isFormValid: PropTypes.bool.isRequired,
  handleSaveAsDraft: PropTypes.func,
  handleSubmitForm: PropTypes.func,
};

export default PaginationButtons;
